<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chicrosthwaite0006#intro">Introduction: Three Centuries of Financial Advice</a></p>
<p class="toc"><a class="xref" href="#/chicrosthwaite0007#ch01"><span class="sm">CHAPTER</span> <span class="sm">1.</span>  Making the Market (1720–1800)</a></p>
<p class="toc"><a class="xref" href="#/chicrosthwaite0008#ch02"><span class="sm">CHAPTER</span> <span class="sm">2.</span>  Navigating the Market (1800–1870)</a></p>
<p class="toc"><a class="xref" href="#/chicrosthwaite0009#ch03"><span class="sm">CHAPTER</span> <span class="sm">3.</span>  Playing the Market (1870–1910)</a></p>
<p class="toc"><a class="xref" href="#/chicrosthwaite0010#ch04"><span class="sm">CHAPTER</span> <span class="sm">4.</span>  Chartists and Fundamentalists (1910–1950)</a></p>
<p class="toc"><a class="xref" href="#/chicrosthwaite0011#ch05"><span class="sm">CHAPTER</span> <span class="sm">5.</span>  Domestic Budgets and Efficient Markets (1950–1990)</a></p>
<p class="toc"><a class="xref" href="#/chicrosthwaite0012#ch06"><span class="sm">CHAPTER</span> <span class="sm">6.</span>  Gurus and Robots (1990–2020)</a></p>
<p class="toc"><a class="xref" href="#/chicrosthwaite0013#conc">Conclusion: Investing through the Crisis</a></p>
<p class="tocbmf"><a class="xref" href="#/chicrosthwaite0014#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chicrosthwaite0015#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chicrosthwaite0017#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-crosthwaite-0005.vue?707d6c3d